import { useState } from 'react';
import { useFeedback } from './use-feedback';

// Executa ações assíncronas das telas exibindo o erro padronizado; runSaving também controla o isSaving do drawer
export function useActionRunner() {
    const feedback = useFeedback();
    const [isSaving, setIsSaving] = useState(false);

    async function run(errorMessage: string, work: () => Promise<void>) {
        try {
            await work();
        } catch (error: any) {
            feedback.showError(errorMessage, error);
        }
    }

    function runWithLoading(errorMessage: string, work: () => Promise<void>) {
        return run(errorMessage, () => feedback.withLoading(work));
    }

    async function runSaving(errorMessage: string, work: () => Promise<void>) {
        setIsSaving(true);
        try {
            await run(errorMessage, work);
        } finally {
            setIsSaving(false);
        }
    }

    return { ...feedback, isSaving, run, runWithLoading, runSaving };
}
